import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SvedPredstInfoType} from "../../../../models/dossier";
import {DossierService} from "../../../../services";
import {IDossierSubService} from "../IDossierSub.service";
import {DossierBasePageComponent} from "../dossierBasePage.component";
import {SvedPredstDossierService} from "./svedPredstDossier.service";
import {
  AlertPanelComponent,
  AlertPanelService,
  ITable,
  ITableCallBack,
  ITableItemDescriptor,
  TableSelectableComponent
} from "@amlCore/components";
import {PredstInfoDossierComponent} from "../components/predstInfo";
import {DictionaryService, UserService} from "@amlCore/services";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {FileSaverService} from "ngx-filesaver";


@Component({
  selector: 'app-sved-predst-dossier',
  styleUrls: ['../dossier.css'],
  templateUrl: './svedPredstDossier.component.html'
})
export class SvedPredstDossierComponent extends DossierBasePageComponent implements OnInit, ITable {

  modelPage: Array<SvedPredstInfoType>;
  itemDescriptor: ITableItemDescriptor;
  isTableTab = true;
  @ViewChild('tableComp', {static: true}) tableComp: TableSelectableComponent;
  @ViewChild('alertObjSave') alertObjToSave: AlertPanelComponent;

  constructor(protected dossierService: DossierService,
              protected route: ActivatedRoute,
              private svedPredstDossierService: SvedPredstDossierService,
              protected dictSrv: DictionaryService,
              protected router: Router,
              protected userService: UserService,
              protected alertPanelSrv: AlertPanelService,
              protected modalService: NgbModal,
              protected fSaver: FileSaverService) {
    super(dossierService, route, dictSrv, router, userService, alertPanelSrv, modalService, fSaver);
  }

  ngOnInit(): void {
    // Инициализация вкладки
    this.modelPage = this.initPage();
    // Описание элемента таблицы
    this.itemDescriptor = {
      create: this.svedPredstDossierService.getSvedPredst.bind(this.svedPredstDossierService, this.modelPage),
      component: PredstInfoDossierComponent,
      params: {
        typePage: this.typePage
      }
    } as ITableItemDescriptor;
  }

  getService(): IDossierSubService {
    return this.svedPredstDossierService;
  }

  callbackItemClosed(event: ITableCallBack) {
    this.saveTableItem(event);
  }

  onSelectChange(): void {
    this.canPrintDossier(this.tableComp.getSelectedModel() as SvedPredstInfoType[]);
  }

  onPrintClick() : void {
    this.uploadPrintForm(this.tableComp.getSelectedModel() as SvedPredstInfoType[], this.alertObjToSave);
  }

  destroy(): void {
    // ТУТ писать реализацию ngOnDestroy для компонента

  }

}
